// extracted by mini-css-extract-plugin
module.exports = {"mega-menu-more-link":"BottomLink_mega-menu-more-link__bSdHj"};